import script from "./FavoritePreviewNavItem.vue?vue&type=script&setup=true&lang=js"
export * from "./FavoritePreviewNavItem.vue?vue&type=script&setup=true&lang=js"

import "./FavoritePreviewNavItem.vue?vue&type=style&index=0&id=15e8d97a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15e8d97a"]])

export default __exports__